export default "/fr/_next/static/assets/images/sprite.39a63b95b852b1342ec9e36a23ec4d25.svg";